import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

const RELOAD_KEY = 'sho-bot:stale-build-reload';

export function lazyPage<Props>(
  load: () => Promise<{ default: ComponentType<Props> }>,
): LazyExoticComponent<ComponentType<Props>> {
  return lazy(async () => {
    try {
      const module = await load();
      sessionStorage.removeItem(RELOAD_KEY);
      return module;
    } catch (error) {
      if (isDynamicImportFailure(error) && sessionStorage.getItem(RELOAD_KEY) === null) {
        sessionStorage.setItem(RELOAD_KEY, '1');
        window.location.reload();
        return new Promise<never>(() => undefined);
      }
      throw error;
    }
  });
}

function isDynamicImportFailure(error: unknown): boolean {
  return (
    error instanceof TypeError &&
    /dynamically imported module|importing a module script|module script/i.test(error.message)
  );
}
